export default __webpack_public_path__ + "static/media/background.44766ba0.png";